'use strict';

/* Polyfills for phantomjs */
require('console-polyfill');
require('phantomjs-polyfill');
require('babel-core/lib/babel/polyfill');

require('param-test');
require('curry-test');
require('debounce-test');
require('memoize-test');
require('returns-test');
require('promises-test');
require('collection-test');



/*****************
 ** WEBPACK FOOTER
 ** ./test/entry/test.js
 ** module id = 0
 ** module chunks = 0
 **/